import {AgeGradeVo} from '../../common/shared/api/gateway/enums/AgeGradeVo.enum';
import {ApiStatusCodeVo} from '../../common/shared/api/nicolas/vo/enums/ApiStatusCodeVo.enum';
import {RedeemCodeVo} from '../../common/shared/api/nicolas/vo/RedeemCodeVo.interface';
import {RedeemCode} from '../generated/types';
import {createAgeGrade} from './AgeGrade';
import {createRedeemCodeType} from './RedeemCodeType';

interface RedeemCodeResult extends RedeemCodeVo {
  result_code?: ApiStatusCodeVo;
}

export function createRedeemCode(redeemCodeVo: RedeemCodeResult): RedeemCode {
  return {
    type: createRedeemCodeType(redeemCodeVo?.type),
    amount: redeemCodeVo?.amount,
    ticket: redeemCodeVo?.ticket,
    title: redeemCodeVo?.title,
    seriesId: redeemCodeVo?.seriesId,
    age: createAgeGrade(redeemCodeVo?.age as AgeGradeVo),
    category: redeemCodeVo?.category,
    shouldRedirect: redeemCodeVo?.should_redirect,
    resultCode: redeemCodeVo?.result_code ?? ApiStatusCodeVo.UnknownError,
  };
}
